import { useState } from 'react';
import { useCompany } from '../CompanyContext';
import { useAuth } from '../AuthContext';
import CompanySetup from './CompanySetup';
import { sans, coral, coralSoft, coralHover } from '../tokens';

export default function CompanySelector() {
  const { companies, profiles, setActiveCompany, refetch } = useCompany();
  const { signOut } = useAuth();
  const [showSetup, setShowSetup] = useState(false);

  const isAnyAdmin = profiles.some(p => p.role === 'admin');
  const canCreate = companies.length === 0 || isAnyAdmin;

  if (showSetup) {
    return (
      <CompanySetup
        onComplete={async () => {
          await refetch();
          setShowSetup(false);
        }}
        onBack={() => setShowSetup(false)}
      />
    );
  }

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: '#FFF8F1', fontFamily: sans,
    }}>
      <div style={{
        background: '#FFFBF6', borderRadius: 12, padding: '44px 40px 36px', width: 420,
        boxShadow: '0 4px 32px rgba(15, 42, 36, 0.08)',
        border: '0.5px solid rgba(15, 42, 36, 0.08)',
      }}>
        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: 8 }}>
          <img src="/finkloz-logo.svg" alt="FinKloz" style={{ height: 48 }} />
        </div>
        <div style={{ fontSize: 12, color: '#6B7B77', marginBottom: 28, textAlign: 'center' }}>
          Select a workspace
        </div>

        {/* Company list */}
        {companies.length > 0 ? (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10, marginBottom: 20 }}>
            {companies.map(c => (
              <button
                key={c.id}
                onClick={() => setActiveCompany(c.id)}
                style={{
                  display: 'flex', alignItems: 'center', gap: 14,
                  padding: '14px 16px', background: '#FFFBF6',
                  border: '1px solid rgba(15, 42, 36, 0.08)',
                  borderRadius: 8, cursor: 'pointer', textAlign: 'left',
                  transition: 'border-color 0.2s, background 0.2s',
                  fontFamily: sans,
                }}
                onMouseEnter={e => { e.currentTarget.style.borderColor = coral; e.currentTarget.style.background = coralSoft; }}
                onMouseLeave={e => { e.currentTarget.style.borderColor = 'rgba(15, 42, 36, 0.08)'; e.currentTarget.style.background = '#FFFBF6'; }}
              >
                <div style={{
                  width: 40, height: 40, borderRadius: 8, background: coralSoft,
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontSize: 16, fontWeight: 700, color: coral, flexShrink: 0,
                }}>
                  {c.name?.charAt(0)?.toUpperCase() || '?'}
                </div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontSize: 14, fontWeight: 600, color: '#0F2A24', marginBottom: 2 }}>
                    {c.name}
                  </div>
                  <div style={{ fontSize: 11, color: '#6B7B77' }}>
                    {c._profile?.role || 'member'}{c.industry ? ` \u00B7 ${c.industry}` : ''}
                  </div>
                </div>
                <div style={{ color: '#9EACA7', fontSize: 18 }}>&rsaquo;</div>
              </button>
            ))}
          </div>
        ) : (
          <div style={{ textAlign: 'center', padding: '20px 0 24px', color: '#6B7B77', fontSize: 13 }}>
            No workspaces yet. Create your first one below.
          </div>
        )}

        {/* Create company button */}
        {canCreate && (
          <button
            onClick={() => setShowSetup(true)}
            style={{
              width: '100%', padding: '10px 0', fontSize: 14, fontWeight: 500,
              background: coral, color: '#FFF8F1', border: 'none', borderRadius: 6,
              cursor: 'pointer', fontFamily: sans, transition: 'background 0.2s',
              marginBottom: 8,
            }}
            onMouseEnter={e => e.currentTarget.style.background = coralHover}
            onMouseLeave={e => e.currentTarget.style.background = coral}
          >
            Create new company
          </button>
        )}

        {/* Sign out */}
        <button
          onClick={signOut}
          style={{
            width: '100%', padding: '8px 0', fontSize: 12, fontWeight: 500,
            background: 'transparent', color: '#6B7B77', border: 'none',
            cursor: 'pointer', fontFamily: sans, marginTop: 8,
          }}
        >
          Sign out
        </button>
      </div>
    </div>
  );
}
